import * as React from 'react';
import { connect } from 'react-redux';

import { INewbuilding } from '../../types/newbuilding';
import { Container } from '../../components/Container';
import { GKCard } from './GKCard';
import { EAdFoxBannerType } from '../Adfox/templates';
import { AdFoxBanner } from '../Adfox';
import { trackingActionToCardNewbuilding, trackingActionOpenContacts } from '../../actions/analytics';

interface IOffersBodyOwnProps {
  newbuildings: INewbuilding[];
}

interface IOffersBodyState {
  adError: boolean;
}

interface IOffersBodyDispatchProps {
  trackingToCardNewbuilding(): void;
  trackingOpenContacts(gaLabelFull: string): void;
}

type TOffersBodyProps = IOffersBodyOwnProps & IOffersBodyDispatchProps;

class OffersBody extends React.PureComponent<TOffersBodyProps, IOffersBodyState> {
  public state: Readonly<IOffersBodyState> = {
    adError: false,
  };

  public render() {
    const { newbuildings, trackingOpenContacts, trackingToCardNewbuilding } = this.props;

    return (
      <Container
        dataMark="OffersBody"
        dataId="offers_body_container"
        borderStyle="solid"
        borderColor="gray_1"
        borderTopWidth={1}
        borderLeftWidth={1}
        borderRightWidth={1}
        borderBottomWidth={0}
      >
        {newbuildings.map((newbuilding, index) =>
          <React.Fragment key={newbuilding.id}>
            {index === 10 && !this.state.adError &&
              <AdFoxBanner
                type={EAdFoxBannerType.PARALLAX}
                positionHint="parallax"
                onFail={this.handleAdError}
              />
            }
            <GKCard
              newbuilding={newbuilding}
              isEven={index !== 0 && index % 2 === 0}
              onPhoneButtonClick={() => trackingOpenContacts(newbuilding.gaLabels.full)}
              trackingOnCardClick={trackingToCardNewbuilding}
            />
          </React.Fragment>,
        )}
      </Container>
    );
  }

  private handleAdError = () => {
    this.setState({
      adError: true,
    });
  }
}

const mapDispatchToProps = {
  trackingToCardNewbuilding: trackingActionToCardNewbuilding,
  trackingOpenContacts: trackingActionOpenContacts,
};

export const OffersBodyContainer = connect<
  null,
  IOffersBodyDispatchProps
>(null, mapDispatchToProps)(OffersBody);
